import { CircularProgress } from '@mui/material'
import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { verificationTokenSSO } from '../store/action';
import { useLocation } from 'react-router-dom';

const DirectSignin = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search)
  const token = queryParams.get('token')
  console.log(token)

  const fetchData = async () => {

    try {
      await props.verificationTokenSSO(token)
    } catch (err) {

    }
  }

  useEffect(() => {
    if (!!token) {
      fetchData(token)
    }
  }, [token]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh', overflow: 'scroll' }}>
      <CircularProgress style={{ color: "#9F0102", width: 100, height: 100 }} />
      <p style={{ marginTop: 16 }}>Verification</p>

      <div>
        <p><b>data verification: </b> {JSON.stringify(props.dataVerificationToken)}</p>
        <p><b>error verification: </b>{JSON.stringify(props.errorVerificationToken)}</p>
      </div>
    </div>
  )
}


const mapDispatchToProps = {
  verificationTokenSSO
}

const mapStateToProps = ({ dataVerificationToken, errorVerificationToken }) => {
  return {
    dataVerificationToken,
    errorVerificationToken
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DirectSignin)
